import { useSearchParams, usePathname } from "next/navigation";
import { useMemo } from "react";

/**
 * Hook for managing return path when navigating to object pages
 * This ensures users return to the correct pagination page when using browser back button
 */
export function useReturnPath() {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  // Generate current return path with search parameters
  const returnPath = useMemo(() => {
    const params = searchParams.toString();
    return params ? `${pathname}?${params}` : pathname;
  }, [pathname, searchParams]);

  // Generate object link without return path parameter
  // returnTo should only be used by auth middleware for login redirects
  const getObjectLink = (objectPath: string) => {
    return objectPath;
  };

  return {
    returnPath,
    getObjectLink,
    hasSearchParams: searchParams.toString().length > 0,
  };
}
